module.exports = __webpack_public_path__ + "img/weekly-board-crown-white.4a618284.svg";